/**
 * Notification shell — FUTURE MS-NOT-090 (IMP-06 stub, GC-P1-04).
 *
 * Scope policy: remains at tenant App shell until push inbox (MS-NOT-090) ships.
 * PaymentProvider / PickupProvider are scoped at checkout boundaries via CheckoutScopeProviders.
 */
import { createContext, useContext, type ReactNode } from 'react';

export interface NotificationScope {
  readonly enabled: boolean;
}

const NotificationContext = createContext<NotificationScope>({ enabled: false });

export function NotificationProvider({ children }: { readonly children: ReactNode }): JSX.Element {
  return (
    <NotificationContext.Provider value={{ enabled: false }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotificationScope(): NotificationScope {
  return useContext(NotificationContext);
}
